import { TThunkAction } from '../../types/redux/thunk';
import { deleteFavoriteRequest } from '../../services/favorite';
import { deleteFavoriteSuccess } from './deleteFavoriteActions';
import { addFavoriteSuccess } from './addFavoriteActions';
import { trackDeleteFavorite } from './tracking';

interface IDeleteFavorite {
  offerId: number;
  label: string;
}

export const deleteFavorite =
  ({ offerId, label }: IDeleteFavorite): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { logger, httpApi }) => {
    try {
      dispatch(deleteFavoriteSuccess({ offerId }));

      const response = await deleteFavoriteRequest({
        httpApi,
        parameters: {
          entityId: offerId,
        },
      });

      const { status } = response || {};

      if (status) {
        trackDeleteFavorite({ label, offerId });
      }

      if (status == null) {
        dispatch(addFavoriteSuccess({ offerId }));
      }
    } catch (error) {
      logger.error(error, {
        offerId,
        domain: 'src/shared/actions/favorite#deleteFavorite()',
        message: error.message,
      });

      dispatch(addFavoriteSuccess({ offerId }));
    }
  };
